<template>
  <v-app>
    <v-main>
      <ltk-error v-if="hasError" />
      <loading-spinner
        v-else-if="isLoading"
        size="40"
        color="grey darken-3"
      />
      <router-view v-show="!isLoading && !hasError" />
    </v-main>
  </v-app>
</template>


<script setup lang="ts">
  import { computed } from "vue";
  import LoadingSpinner from "./components/LoadingSpinner.vue";
  import LtkError from "./views/LtkError.vue";
  import { useAppStore } from "./stores/app";

  const appStore = useAppStore();
  const hasError = computed(() => appStore.hasError);
  const isLoading = computed(() => appStore.isLoading);
</script>

